// @flow

import React, { PureComponent } from "react";
import {
  MessageContainer,
  Image,
  TalentConfirmationHeader
} from "./styled-components";
import Icon from "../../_static/Icons";
import { talentShape } from "../../_static/Icons/icons";

import buildColor from "../../_static/ColorPalette";

type Props = {
  /**
   * Talent image
   */
  talentImage: string,
  /**
   * Talent message for the user
   */
  message: string
};

export default class TalentPickConfirmationHeader extends PureComponent<Props> {
  static defaultProps = {
    talentImage: "",
    message: ""
  };

  render() {
    return (
      <TalentConfirmationHeader>
        {this.props.talentImage ? (
          <Image
            src={this.props.talentImage}
            alt={this.props.talentImage}
            data-qa-label="talentImg"
          />
        ) : (
          <Icon
            icon={talentShape}
            color={buildColor("grey", "600")}
            size={100}
            data-qa-label="talentImg"
          />
        )}
        {this.props.message && (
          <MessageContainer data-qa-label="talentMsg">
            <p>{this.props.message}</p>
          </MessageContainer>
        )}
      </TalentConfirmationHeader>
    );
  }
}
